import SelectAutocomplete from './select-autocomplete';

export default SelectAutocomplete;